import React from "react";
import { Form} from "react-bootstrap";
import "../styles/JoinOurTeamInput.css"

interface IJoinOurTeamInput {
  title: string,
  placholder: string,
  setVal: React.Dispatch<React.SetStateAction<string>>,
  val: string,
  type?: string,
  inputMode?: "text" | "numeric" | "tel" | "email",
  format?: (v: string) => string,
  isInvalid?: boolean,
  onBlur?: () => void
}

export const JoinOurTeamInput = ({title, placholder, setVal, val, type = "text", inputMode, format, isInvalid, onBlur}: IJoinOurTeamInput) => {
  return (
    <>
      <label style={{textAlign: "left", width: "100%"}}>{title}</label>
      <Form.Control
        type={type}
        inputMode={inputMode}
        value={val}
        onChange={e => setVal(format ? format(e.target.value) : e.target.value)}
        onBlur={onBlur}
        placeholder={placholder}
        isInvalid={isInvalid}
        className="v_a_joti_contacts_form_inp"
      />
    </>
  );
};
